module.exports = __webpack_public_path__ + "static/image/history/pc/201303.jpg?ddea4adb";